import { __decorate } from '../../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './footer-nav.scss.js';
import '../footer-nav-item/index.js';

class FooterNav extends s {
    constructor() {
        super(...arguments);
        this.title = '';
    }
    render() {
        return $ `<nav class="footer-nav" role="navigation" aria-label="${this.title || 'Footer group'}"><h3 class="footer-nav__title">${this.title}</h3><slot></slot></nav>`;
    }
}
FooterNav.styles = css_248z;
__decorate([
    e({ type: String })
], FooterNav.prototype, "title", void 0);
customElements.define('footer-nav', FooterNav);

export { FooterNav };
